import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _classCallCheck from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
import { Order, OrderProjectionDTO } from "./models";
import { getApiHeader, getApiHeaderWithContentType } from "./token";
import config from "../dal/config";
export var OrderDTOSearchResults = function OrderDTOSearchResults() {
  _classCallCheck(this, OrderDTOSearchResults);
  this.ordersDTO = new Array(new Order());
  this.orderProjectionsDTO = new Array(new OrderProjectionDTO());
};
export var cancelOrder = function cancelOrder(code, id, reason, type) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.post("api/Orders/".concat(code, "/").concat(id, "/cancel/").concat(type), JSON.stringify(reason), getApiHeaderWithContentType("application/json"));
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
var postOrder = function postOrder(code, order) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axios.post("api/Orders/".concat(code), order, getApiHeader());
          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};
var getReport = function getReport(code, orderId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = getApiHeader();
            options.responseType = "blob";
            _context3.next = 4;
            return axios.get("api/orders/".concat(code, "/").concat(orderId, "/report"), options);
          case 4:
            response = _context3.sent;
            return _context3.abrupt("return", response.data);
          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};
var patchOrder = function patchOrder(code, operations, id) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var invalidOperations, apiHeader, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            invalidOperations = operations.filter(function (o) {
              return window.appConfig.invalidPatchOperationPaths.some(function (x) {
                return o.path.toLowerCase().includes(x.toLowerCase());
              });
            }); //remove operations since paths are not saved in the db
            invalidOperations.forEach(function (io) {
              var index = operations.indexOf(io);
              if (index > -1) {
                operations.splice(index, 1);
              }
            });
            apiHeader = getApiHeader();
            apiHeader.headers["Content-Type"] = "application/json-patch+json";
            _context4.next = 6;
            return axios.patch("api/Orders/".concat(code, "/").concat(id), JSON.stringify(operations), apiHeader);
          case 6:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);
          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};
var postCTC = function postCTC(model) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return axios.post("api/Orders/clientTestCodes", model, getApiHeader());
          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response.data);
          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
};
var approveOrder = function approveOrder(code, id, addOn, assignNewLabNumber) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var apiHeader, queryParams, queryArray, url, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            apiHeader = getApiHeader();
            apiHeader.headers["Content-Type"] = "application/json";
            queryParams = "";
            if (addOn !== undefined || assignNewLabNumber !== undefined) {
              queryArray = [];
              if (addOn !== undefined) {
                queryArray.push("isAddOn=".concat(addOn));
              }
              if (assignNewLabNumber !== undefined) {
                queryArray.push("assignNewLabNumber=".concat(assignNewLabNumber));
              }
              queryParams = "?".concat(queryArray.join("&"));
            }
            url = "api/Orders/".concat(code, "/").concat(id, "/approve").concat(queryParams);
            _context6.next = 7;
            return axios.post(url, null, apiHeader);
          case 7:
            response = _context6.sent;
            return _context6.abrupt("return", response.data);
          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
};
var getOrder = function getOrder(code, id) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return axios.get("api/Orders/".concat(code, "/").concat(id), getApiHeader());
          case 2:
            response = _context7.sent;
            return _context7.abrupt("return", response.data);
          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
};
var getOrderBySampleId = function getOrderBySampleId(code, sampleId, tempSampleId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return axios.get("api/Orders/".concat(code, "/sampleId/").concat(sampleId).concat(tempSampleId ? "?tempSampleId=".concat(tempSampleId) : ""), getApiHeader());
          case 2:
            response = _context8.sent;
            return _context8.abrupt("return", response.data);
          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
};
var getOrders = function getOrders(code, query, pageNumber, pageSize, orderBy, isAscending, getProjections) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var page, top, skip, institutionCodes, endpoint, response, searchResult, retVal;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            page = pageNumber || 1;
            top = pageSize || 25;
            skip = (page - 1) * top;
            if (orderBy) {
              if (!query.includes("orderBy")) {
                query += "&orderBy=".concat(orderBy);
              }
              if (isAscending !== undefined) {
                query += "&isAscending=".concat(isAscending);
              }
            }
            institutionCodes = sessionStorage.getItem("institutionCodes");
            if (institutionCodes && !institutionCodes.includes(code)) {
              institutionCodes += ",".concat(code);
            }
            endpoint = "api/Orders/".concat(getProjections ? "v2/" : "").concat(code, "?hospitalCodes=").concat(institutionCodes, "&skip=").concat(skip, "&top=").concat(top, "&").concat(query);
            _context9.next = 9;
            return axios.get(endpoint, getApiHeader());
          case 9:
            response = _context9.sent;
            searchResult = response.data;
            if (!(searchResult.total && searchResult.total <= skip)) {
              _context9.next = 13;
              break;
            }
            throw new Error("Invalid page");
          case 13:
            retVal = {
              pageCount: Math.ceil((searchResult.total || 0) / top),
              top: searchResult.top,
              skip: searchResult.skip,
              total: searchResult.total,
              orderProjectionsDTO: [],
              ordersDTO: []
            };
            if (getProjections) {
              retVal.orderProjectionsDTO = searchResult.orderProjectionsDTO;
            } else {
              retVal.ordersDTO = searchResult.ordersDTO;
            }
            return _context9.abrupt("return", retVal);
          case 16:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
};
var sendVob = function sendVob(code, id) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee0() {
    var response;
    return _regeneratorRuntime.wrap(function _callee0$(_context0) {
      while (1) {
        switch (_context0.prev = _context0.next) {
          case 0:
            _context0.next = 2;
            return axios.patch("api/Orders/".concat(code, "/").concat(id, "/vob"), {}, getApiHeader());
          case 2:
            response = _context0.sent;
            return _context0.abrupt("return", response.data);
          case 4:
          case "end":
            return _context0.stop();
        }
      }
    }, _callee0);
  }));
};
var postFeedback = function postFeedback(code, feedbackDTO) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee1() {
    var response;
    return _regeneratorRuntime.wrap(function _callee1$(_context1) {
      while (1) {
        switch (_context1.prev = _context1.next) {
          case 0:
            _context1.next = 2;
            return axios.post("api/Orders/".concat(code, "/feedback"), feedbackDTO, getApiHeader());
          case 2:
            response = _context1.sent;
            return _context1.abrupt("return", response.data);
          case 4:
          case "end":
            return _context1.stop();
        }
      }
    }, _callee1);
  }));
};
export var addReq = function addReq(code, id, htmlContent) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var options, formData, url, response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            options = getApiHeader();
            formData = new FormData();
            formData.append("htmlContent", htmlContent);
            url = "api/orders/".concat(code, "/").concat(id, "/add-req");
            _context10.next = 6;
            return axios.post(url, formData, options);
          case 6:
            response = _context10.sent;
            return _context10.abrupt("return", response.data);
          case 8:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
};
var removeOrder = function removeOrder(code, id) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var options, url, response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            options = getApiHeader();
            url = "api/orders/".concat(code, "/").concat(id);
            _context11.next = 4;
            return axios.delete(url, options);
          case 4:
            response = _context11.sent;
            return _context11.abrupt("return", response.data);
          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
};
var uploadManifest = function uploadManifest(manifestInfo, file) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var options, url, formData, response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            options = getApiHeader();
            url = "api/orders/test-code/".concat(manifestInfo.testCode, "/hospital-code/").concat(manifestInfo.institutionCode, "/import?enteredBy=").concat(manifestInfo.enteredBy);
            formData = new FormData();
            formData.append("file", file);
            formData.append("referral1", manifestInfo.referral1.toString());
            formData.append("validateOrderTestCode", "false");
            _context12.next = 8;
            return axios.post(url, formData, options);
          case 8:
            response = _context12.sent;
            return _context12.abrupt("return", response.data);
          case 10:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
};
export var postGCAppointment = function postGCAppointment(payload) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    var url, response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            url = "".concat(config.apiUrl, "api/Orders/GCAppointment");
            _context13.next = 3;
            return axios.post(url, payload, {
              headers: {
                "Content-Type": "application/json"
              }
            });
          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response.data);
          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
};
export default {
  cancelOrder: cancelOrder,
  postOrder: postOrder,
  postCTC: postCTC,
  patchOrder: patchOrder,
  approveOrder: approveOrder,
  getOrder: getOrder,
  getOrderBySampleId: getOrderBySampleId,
  getOrders: getOrders,
  getReport: getReport,
  sendVob: sendVob,
  postFeedback: postFeedback,
  addReq: addReq,
  removeOrder: removeOrder,
  uploadManifest: uploadManifest,
  postGCAppointment: postGCAppointment
};